import type { ComponentType } from 'react'
import Hero from '../components/sections/Hero'
import Brands from '../components/sections/Brands'
import Companies from '../components/sections/Companies'
import InventorySection from '../components/inventory/InventorySection'
import WhyChooseUs from '../components/sections/WhyChooseUs'
import Process from '../components/sections/Process'
import Advantages from '../components/sections/Advantages'
import BankPartners from '../components/finance/BankPartners'
import SpecialOffer from '../components/sections/SpecialOffer'
import VideoReviews from '../components/sections/VideoReviews'
import Testimonials from '../components/sections/Testimonials'
import ClientReach from '../components/sections/ClientReach'
import Faqs from '../components/sections/Faqs'

/* Which component draws which section.
 *
 * The keys are the ones in api/src/config/cms.ts, and this map is the only
 * place the two halves have to agree. A section in the layout with no
 * component here is skipped rather than crashing the page — which is what
 * lets the API grow a section before the storefront can draw it, and lets an
 * old cached layout in somebody's browser name one that has since gone.
 */
export const SECTION_COMPONENTS: Record<string, ComponentType> = {
  hero: Hero,
  brands: Brands,
  companies: Companies,
  inventory: InventorySection,
  why: WhyChooseUs,
  process: Process,
  advantages: Advantages,
  banks: BankPartners,
  offer: SpecialOffer,
  videoReviews: VideoReviews,
  testimonials: Testimonials,
  clientReach: ClientReach,
  faqs: Faqs,
}

/* The order the page ships in, for the first frame of a first-ever visit —
   before the layout has been fetched and with nothing in this browser's
   cache. It is the registry's own order, so the site has a complete home page
   with no network at all. */
export const DEFAULT_ORDER = [
  'hero',
  'brands',
  'companies',
  'inventory',
  'why',
  'process',
  'advantages',
  'banks',
  'offer',
  'videoReviews',
  'testimonials',
  'clientReach',
  'faqs',
]
